module.exports = __webpack_public_path__ + "static/media/BGWithChart@2x.c4789873.png";